// extracted by mini-css-extract-plugin
export default {"htmlOpen":"MYNGzf","bodyOpen":"rnz7UT","overlay":"RqX7rv","root":"VjbdFU","afterOpen":"G7KeYn","beforeClose":"klObVV"};